module.exports = __webpack_public_path__ + "img/album01_05.3c215952.jpg";